export default __webpack_public_path__ + "static/media/ic-arrow-grey.37ad0e3f.svg";